/* OREN — Cart drawer: AJAX add-to-cart, qty changes, header count sync */
(function(){
  var drawer=document.querySelector('[data-cart-drawer]');
  if(!drawer) return;
  var itemsEl=drawer.querySelector('[data-cdw-items]');
  var emptyEl=drawer.querySelector('[data-cdw-empty]');
  var subEl=drawer.querySelector('[data-cdw-subtotal]');
  var errEl=drawer.querySelector('[data-cdw-error]');
  var checkoutBtn=drawer.querySelector('[data-cdw-checkout]');

  function money(c){
    if(c%100===0) return (c/100)+' \u20ac';
    return (c/100).toFixed(2).replace('.',',')+' \u20ac';
  }
  function esc(s){
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function thumb(url){
    if(!url) return '';
    return url+(url.indexOf('?')>-1?'&':'?')+'width=240';
  }

  function render(cart){
    document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent=cart.item_count; });
    if(!cart.items.length){
      itemsEl.innerHTML='';
      emptyEl.hidden=false;
      checkoutBtn.setAttribute('disabled','');
      subEl.textContent=money(0);
      return;
    }
    emptyEl.hidden=true;
    checkoutBtn.removeAttribute('disabled');
    subEl.textContent=money(cart.items_subtotal_price);
    itemsEl.innerHTML=cart.items.map(function(it){
      var img=it.image?('<img src="'+thumb(it.image)+'" alt="" loading="lazy">'):'';
      var variant=(it.variant_title&&it.variant_title!=='Default Title')
        ?'<div class="cdw-variant">'+esc(it.variant_title)+'</div>':'';
      return '<div class="cdw-item" data-key="'+it.key+'">'
        +'<a class="cdw-thumb" href="'+it.url+'">'+img+'</a>'
        +'<div class="cdw-mid">'
          +'<a class="cdw-title" href="'+it.url+'">'+esc(it.product_title)+'</a>'
          +variant
          +'<div class="cdw-qty">'
            +'<button type="button" data-cdw-minus aria-label="Decrease quantity">\u2212</button>'
            +'<span>'+it.quantity+'</span>'
            +'<button type="button" data-cdw-plus aria-label="Increase quantity">+</button>'
          +'</div>'
        +'</div>'
        +'<div class="cdw-right">'
          +'<div class="cdw-price">'+money(it.final_line_price)+'</div>'
          +'<button type="button" class="cdw-remove" data-cdw-remove>Remove</button>'
        +'</div>'
      +'</div>';
    }).join('');
  }

  function refresh(){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(render);
  }
  function open(){
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
  }
  function close(){
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
  }

  drawer.addEventListener('click',function(e){
    if(e.target.closest('[data-cdw-close]')||e.target.classList.contains('cdw-overlay')) close();
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&drawer.classList.contains('open')) close();
  });

  // Quantity / remove (event delegation)
  itemsEl.addEventListener('click',function(e){
    var item=e.target.closest('.cdw-item');
    if(!item) return;
    var key=item.getAttribute('data-key');
    var qtyEl=item.querySelector('.cdw-qty span');
    var q=parseInt(qtyEl?qtyEl.textContent:'1',10)||1;
    var newQ=null;
    if(e.target.closest('[data-cdw-plus]')) newQ=q+1;
    else if(e.target.closest('[data-cdw-minus]')) newQ=Math.max(0,q-1);
    else if(e.target.closest('[data-cdw-remove]')) newQ=0;
    if(newQ===null) return;
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:newQ})
    }).then(function(r){ return r.json(); }).then(render).catch(function(){ refresh(); });
  });

  // Header cart links open the drawer instead of navigating
  document.querySelectorAll('.nav a.cart, .nav-drawer-inner a[href*="/cart"]').forEach(function(a){
    a.addEventListener('click',function(e){
      e.preventDefault();
      refresh().then(open);
    });
  });

  // Intercept add-to-cart forms (AJAX add, then open drawer)
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form.matches||!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn=form.querySelector('[name="add"]');
    if(btn) btn.setAttribute('data-cdw-busy','');
    fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}})
      .then(function(r){
        if(!r.ok) return r.json().then(function(j){ throw new Error(j.description||'Could not add to cart.'); });
        return r.json();
      })
      .then(function(){
        if(errEl){ errEl.hidden=true; errEl.textContent=''; }
        return refresh();
      })
      .then(open)
      .catch(function(err){
        if(errEl){ errEl.textContent=err.message; errEl.hidden=false; }
        refresh().then(open);
      })
      .then(function(){ if(btn) btn.removeAttribute('data-cdw-busy'); });
  });
})();
